import {useDebugValue} from 'react';

import {undef} from '../../../utils';

import {useTranslations} from './';

const defaultGuestsTranslations = {
    adultText: 'Adult',
    adultsText: 'Adults',
    childText: 'Child',
    childrenText: 'Children',
    guestText: 'Guest',
    guestsText: 'Guests',
    petsText: 'Pets',
    label: 'Guests',
    guestLabel: undef,
    modalTitle: 'Select guests',
    adultsLabel: undef,
    childrenLabel: undef,
    petLabel: 'Pets',
    petNoLabel: 'No',
    petYesLabel: 'Yes',
    petMessage: 'Only properties that allow pets will be shown',
    applyButtonLabel: 'Apply',
    clearButtonLabel: 'Clear',
    continueButtonLabel: 'Continue'
};

function useGuestsTranslations(props) {
    const {
        guestsTranslations: propsGuestsTranslations
    } = props;

    const {
        translations: guestsTranslations
    } = useTranslations(defaultGuestsTranslations, propsGuestsTranslations);

    const result = {
        guestsTranslations
    };

    useDebugValue(result);

    return result;
}

export {useGuestsTranslations};
